export enum NetworkStatusCategory {
  PN_NETWORK_UP_CATEGORY = 'PNNetworkUpCategory',
  PN_NETWORK_DOWN_CATEGORY = 'PNNetworkDownCategory',
  PN_RECONNECTED_CATEGORY = 'PNReconnectedCategory',
  PN_CONNECTED_CATEGORY = 'PNConnectedCategory',
  PN_TIMEOUT_CATEGORY = 'PNTimeoutCategory',
}
